import { KeyboardEvent, ChangeEvent } from 'react';
import clsx from 'clsx';
import Image from 'next/image';

interface IProps {
  query: string;
  handleChange: (event: ChangeEvent<HTMLInputElement>) => void;
  inputClassname?: string;
  wrapperClassname?: string;
  icon?: string;
  placeholder: string;
  greenLoopIcon?: boolean;
  onInputEnterPress?: (event: KeyboardEvent<HTMLInputElement>) => void;
}

export const SearchField = ({
  query,
  handleChange,
  wrapperClassname,
  inputClassname,
  placeholder,
  greenLoopIcon = false,
  onInputEnterPress,
}: IProps) => {
  return (
    <div
      data-testid="search-field"
      className={clsx(
        `
         flex items-center
         border-grey-1 bg-white relative
         border shadow-light-gray-outline rounded-[8px]
         `,
        {
          [`${wrapperClassname}`]: wrapperClassname,
        },
      )}
    >
      <Image
        className="absolute top-1/2 translate-y-[-50%] left-[14px] pointer-events-none"
        src={greenLoopIcon ? '/icons/search-green.svg' : '/icons/search.svg'}
        alt="Search Icon"
        width={20}
        height={20}
      />
      <input
        type="text"
        data-testid="search-input"
        className={clsx('border-none focus:outline-none focus:border-grey-1 focus:ring-0 w-full', {
          [`${inputClassname}`]: inputClassname,
        })}
        value={query}
        onChange={handleChange}
        placeholder={placeholder}
        onKeyDown={onInputEnterPress}
      />
    </div>
  );
};
